export const BASE_URL = process.env.REACT_APP_ENV === "PROD" ? "https://api.arbventures.in" : "https://api-dev.arbventures.in";
// https://api.arbventures.in
// https://arbventures.onrender.com
// https://api-dev.arbventures.in